/* Surat Mobile Shell — JS fallback for viewport detection
   Isolated: does NOT touch tbw-app.js or any existing theme JS.
   Purpose: belt-and-suspenders check that a desktop-width visitor
   on the mobile template gets redirected to the desktop experience.
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Only run if the mobile shell actually rendered
    if (!document.querySelector('.surat-ms')) return;

    // If viewport is desktop-wide, the UA sniff likely mis-routed.
    // Redirect to the same URL without the mobile template param.
    if (window.innerWidth >= 768) {
      var url = new URL(window.location.href);
      // Remove ?view=mobile if present (used by alternate template)
      url.searchParams.delete('view');
      // Use sessionStorage to prevent redirect loops
      if (!sessionStorage.getItem('surat_ms_redirected')) {
        sessionStorage.setItem('surat_ms_redirected', '1');
        window.location.replace(url.pathname);
      }
    }
  });
})();